import React from "react";
import { PromoState } from "../../../../globals";
import { PromoButtonWrapper } from "../index.stitches";
import { getPromoButtonAriaLabel } from "../utils";
import { Icon } from "@washingtonpost/wpds-ui-kit";
import { Play, Loading, Mute } from "@washingtonpost/wpds-assets";
import PropTypes from "prop-types";

export const PromoButton = ({
  promoState,
  isVideoTypeLive,
  isLivePreviewEnabled,
  title,
  duration
}) => {
  const isLoading = promoState !== PromoState.READY;
  const isLivePreview = isLivePreviewEnabled && isVideoTypeLive;
  return (
    <PromoButtonWrapper
      aria-label={getPromoButtonAriaLabel(isVideoTypeLive, title, duration)}
      id={`orca-promo-button`}
      data-testid={`orca-promo-button`}
      icon="center"
      data-state={promoState.toLowerCase()}
      data-state-live={isVideoTypeLive}
      data-state-live-preview={isLivePreviewEnabled}
    >
      <Icon className="wpds-icon">
        {isLoading ? (
          <Loading data-testid="loading-icon" />
        ) : isLivePreview ? (
          <Mute data-testid="mute-icon" />
        ) : (
          <Play data-testid="play-icon" />
        )}
      </Icon>
    </PromoButtonWrapper>
  );
};

PromoButton.propTypes = {
  promoState: PropTypes.string,
  isVideoTypeLive: PropTypes.bool,
  isLivePreviewEnabled: PropTypes.bool,
  title: PropTypes.string,
  duration: PropTypes.object
};
